import React from 'react';
import styles from './css/GenericModal.module.css';
import { Button } from '@/components/Buttons';

interface GenericConfirmModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
  type: "escape" | "delete";
}

const GenericConfirmModal: React.FC<GenericConfirmModalProps> = ({
  isOpen,
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  loading,
  type,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.h2}>{title}</h2>
        <p className={styles.p}>{description}</p>
        <div className={styles.buttonContainer}>
          <Button data-testid="popup-cancel-btn" icon='no' id='cancel' popupstyle="gray" onClick={onCancel} text={cancelText}></Button>
          <Button data-testid="popup-confirm-btn" icon='no' id='confirm' popupstyle="red" onClick={onConfirm} loading={type === "delete" ? loading : false} disabled={type === "delete" ? loading : false} text={confirmText}></Button>
        </div>
      </div>
    </div>
  );
};

export default GenericConfirmModal;